import React, { useEffect, useState, useMemo, useRef } from "react";
import { withNamespaces } from "react-i18next";
import { AvForm, AvField } from "availity-reactstrap-validation";
import {
  Row,
  Col,
  Card,
  CardBody,
  CardTitle,
  CardSubtitle,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  Button,
  Label,
  Spinner,
} from "reactstrap";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import Breadcrumb_2Items from "../../../../components/Common/Breadcrumb_2Items";
import BootstrapTable from "react-bootstrap-table-next";
import "../../../../../node_modules/react-bootstrap-table-next/dist/react-bootstrap-table2.min.css";
import ToolkitProvider, { Search } from "react-bootstrap-table2-toolkit";
import "../../../../../node_modules/react-bootstrap-table2-toolkit/dist/react-bootstrap-table2-toolkit.min.css";
import { postSubmitForm } from "../../../../helpers/forms_helper";
import {
  convertToLowestUnit,
  GetUpdatedDelivered,
  formatUnitsForReport,
} from "../../../../helpers/units";
import showNotification from "../../../../helpers/show_notification";
import preloader from "../../../../helpers/preloader";
import calculatePrice from "../../../../helpers/calculate_price";
import cellEditFactory from "react-bootstrap-table2-editor";
import UpdateQuantityModal from "../../../../components/UpdateQuantityModal";
import OrderDetails from "../../../../components/Orders/Items/DeficitOrderDetails";
import ViewCompleteDetails from "../../../../components/Orders/Items/ViewCompleteDetails";
import {
  columnsExternal,
  dispatchColumns,
  expandColumns,
  poColumns,
} from "./Columns";
import moment from "moment";
import Select from "react-select";
import CloseOrderModal from "../../../../components/Orders/Items/CloseOrderModal";

const DispatchAndGenratePO = (props) => {
  const { SearchBar } = Search;
  const refForForm = useRef(null);
  const [dateFrom, setDateFrom] = useState();
  const [dateTo, setDateTo] = useState();
  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;

    return [year, month, day].join("-");
  }

  useEffect(() => {
    const currentDay = new Date();
    setDateFrom(formatDate(currentDay));
    setDateTo(formatDate(currentDay));
  }, []);

  useEffect(() => {
    loadAllStores();
    loadAllCategories();
  }, []);

  const [confirmClose, setConfirmClose] = useState(false);
  const [selectedStore, setSelectedStore] = useState("All");
  const [selectedCategory, setSelectedCategory] = useState("All");
  const selectRef = useRef();
  const [isDispatched, setIsDispatched] = useState(false);

  const [openBucketModal, setOpenBucketModal] = useState(false);
  const [selectedOrder, setSelectedOrder] = useState([]);
  const [toDispatch, setToDispatch] = useState([]);
  const [toGeneratePO, setToGeneratePo] = useState([]);

  const memoizedToDispatch = useMemo(() => toDispatch, [toDispatch]);
  const memoizedToGeneratePO = useMemo(() => toGeneratePO, [toGeneratePO]);

  useEffect(() => {
    loadAllOrders();
  }, [selectedCategory, selectedStore]);

  const [allOrders, setAllOrders] = useState([]);
  const isUrgentOrders = props.location.pathname === "/items/urgent_orders";
  const loadAllOrders = async () => {
    try {
      preloader(true);
      setAllOrders([]);
      let allData = [];

      const url = isUrgentOrders
        ? process.env.REACT_APP_BASEURL + "itemorders/getall_urgent_orders"
        : process.env.REACT_APP_BASEURL + "itemorders/getall";

      const payload = isUrgentOrders
        ? {
            branch: selectedStore,
            category: selectedCategory,
            status: [
              "Approved",
              "Dispatched",
              "PO is pending",
              "Partially Dispatched",
              "Delivered",
              "Received",
              "Partially Received",
            ],
          }
        : {
            branch: selectedStore,
            category: selectedCategory,
            date_from: dateFrom,
            date_to: dateTo,
            status: [
              "Approved",
              "Dispatched",
              "PO is pending",
              "Partially Dispatched",
              "Delivered",
              "Received",
              "Partially Received",
            ],
          };

      if (!isUrgentOrders) {
        const daysDiff = moment(dateTo).diff(dateFrom, "days");

        if (daysDiff < 0) {
          setAllOrders([]);
          showNotification("Invalid date range.", "Error");
          return false;
        }

        if (daysDiff > 31) {
          setAllOrders([]);
          showNotification(
            "Total number of days cannot be more than 31.",
            "Error",
          );
          return false;
        }

        if (daysDiff > 5) {
          const daysPerPart = Math.ceil(daysDiff / 4);
          let startDate = moment(dateFrom);
          let endDate = moment(dateTo);

          for (let i = 0; i < 4; i++) {
            const currentEndDate = moment.min(
              startDate.clone().add(daysPerPart, "days"),
              endDate,
            );

            const response = await postSubmitForm(url, {
              ...payload,
              date_from: startDate.format("YYYY-MM-DD"),
              date_to: currentEndDate.format("YYYY-MM-DD"),
            });

            if (response && response.status === 1) {
              const result = response.data.filter(
                (data) =>
                  (data.order_for && data.order_for === "substore deficit") ||
                  !data.order_for,
              );
              allData = [...allData, ...result];
            }

            startDate = currentEndDate.clone().add(1, "day");
            if (startDate.isAfter(endDate)) break;
          }
        } else {
          // Single API call for small date ranges
          const response = await postSubmitForm(url, payload);
          if (response && response.status === 1) {
            const result = response.data.filter(
              (data) =>
                (data.order_for && data.order_for === "substore deficit") ||
                !data.order_for,
            );
            allData = [...allData, ...result];
          }
        }
      } else {
        // Handle urgent orders
        const response = await postSubmitForm(url, payload);
        if (response && response.status === 1) {
          const result = response.data.filter(
            (data) =>
              (data.order_for && data.order_for === "substore deficit") ||
              !data.order_for,
          );
          allData = [...allData, ...result];
        } else {
          showNotification(response.message || "Error", "Error");
        }
      }

      if (allData.length <= 0) {
        showNotification("No Orders data found", "Error");
      }

      setAllOrders(allData);
    } catch (error) {
      console.error("Error loading orders:", error);
      showNotification("Error loading orders", "Error");
    } finally {
      preloader(false);
    }
  };
  const [allMappedItems, setAllMappedItems] = useState([]);
  const loadMappedItems = async (store) => {
    try {
      preloader(true);
      let url = process.env.REACT_APP_BASEURL + "items/get_mapped_items";
      const response = await postSubmitForm(url, { store_id: store._id });
      if (response && response.status === 1) {
        const selectOptions = response.data
          .filter((d) => d.is_active)
          .map((item, ind) => ({
            // ...item,
            uniqueId: `${Date.now()}-${ind + 1}`,
            available: item.available,
            category: item.category,
            sub_category: item.sub_category,
            central_available: item.store_available,
            direct_po: item.direct_po ?? false,
            dispatch_quantity: [],
            item_id: item.item_id,
            unit_for_max_order: item.unit_for_max_order,
            max_order_limit: item.max_order_limit,
            unit_levels: item.unit_levels,
            order_to: item.order_to ?? "CENTRAL STORE",
            po_price: item.po_price ?? 0,
            quantity: [],
            unit_for_po: item.unit_for_po,
            is_po_allowed: item.is_po_allowed,
            name: item.name,
            label: item.name,
            value: item.item_id,
          }));
        setAllMappedItems(selectOptions);
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      showNotification(error, "Error");
    } finally {
      preloader(false);
    }
  };

  const handleUpdateOrder = async (item, qty, source, bucket) => {
    let payload = {
      itemorder_id: selectedOrder._id,
      item_id: item.item_id,
      source: source,
      bucket: bucket,
    };
    if (source === "Update") {
      Object.assign(payload, {
        quantity: qty.map(({ unit, value }) => ({ unit, value })),
      });
    }
    let url = process.env.REACT_APP_BASEURL + "itemorders/update_buckets";
    const response = await postSubmitForm(url, payload);
    if (response && response.status === 1) {
      loadAllOrders();
      setSelectedItem();
      return true;
    } else {
      showNotification(response.message, "Error");
      return false;
    }
  };
  var POGenerated = selectedOrder.po_bucket_status === "PO Generated";
  var POSaved = selectedOrder.po_bucket_status === "PO Saved";
  var ItemsDispatched = selectedOrder.dispatch_bucket_status === "Dispatched";
  var isTransferrable = POGenerated || ItemsDispatched;
  const [selectedRowsUnit, setSelectedRowsUnit] = useState([]);
  const [enterQuantityModal, setEnterQuantityModal] = useState(false);
  const [selectedItem, setSelectedItem] = useState();
  const [editUnitModal, setEditUnitModal] = useState(false);
  const [editFor, setEditFor] = useState("");

  const [loadingCategory, setLoadingCategory] = useState(null);
  const loadSuupliers = async (e) => {
    try {
      if (e?.suppliers.length > 0) return;
      if (selectedOrder.po_bucket_status === "PO Generated") return;

      setLoadingCategory(e.category);
      let url = process.env.REACT_APP_BASEURL + "suppliers/get_by_categories";
      let response = await postSubmitForm(url, { categories: [e.category] });
      if (response.status === 1) {
        const supplier = response.data.sort((a, b) =>
          a.name.localeCompare(b.name),
        );
        // const UpdatedWithSupplier = toGeneratePO.map((item) =>
        //   item.category === e.category ? { ...item, suppliers: supplier } : item
        // );
        const updatedSuppliers = supplier.map((s) => ({
          value: s.value || s.name,
          name: s.name,
        }));
        setToGeneratePo((prev) =>
          prev.map((itm) =>
            itm.category === e.category
              ? {
                  ...itm,
                  suppliers: updatedSuppliers,
                  selSupp: itm.selSupp || e.selSupp,
                }
              : itm,
          ),
        );
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setLoadingCategory(null);
    }
  };

  const populateCartFromDraft = async (po_bucket) => {
    const newCartCategorizesItems = po_bucket.map((category) => ({
      category: category.category,
      selSupp: category.supplier,
      items: category.items.map((item) => ({
        ...item,
        quantity: item.po_quantity,
        category: category.category,
      })),
      suppliers: [],
    }));
    // console.log(newCartCategorizesItems,"NEw");
    setToGeneratePo(newCartCategorizesItems);

    for (const category of newCartCategorizesItems) {
      await loadSuupliers(category);
    }
  };

  const [allStores, setAllStores] = useState([]);
  const loadAllStores = async () => {
    let url = process.env.REACT_APP_BASEURL + "stores/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      const res = response.data.filter(
        (store) =>
          store.type !== "Main Store" && store.type !== "CENTRAL STORE",
      );
      setAllStores(res);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const [allCategories, setAllCategories] = useState([]);
  const loadAllCategories = async () => {
    let url = process.env.REACT_APP_BASEURL + "itemcategories/getall";
    let response = await postSubmitForm(url, "");
    if (response.status === 1) {
      setAllCategories(response.data);
    } else {
      showNotification(response.message, "Error");
    }
  };

  const handleSupplierSelection = (e, item) => {
    const selectedSupplier = item.suppliers.find(
      (supplier) => supplier.value === e.target.value,
    );
    setToGeneratePo((prevCategorisezItem) =>
      prevCategorisezItem.map((itm) =>
        itm.category === item.category
          ? {
              ...itm,
              selSupp: {
                id: selectedSupplier?.value,
                name: selectedSupplier?.name,
              },
            }
          : itm,
      ),
    );
  };

  const formatQuantity = (qty) => {
    return qty.map((item) => `${item.value} ${item.unit}`).join(" ");
  };

  const handleTransferItem = async (item, status) => {
    try {
      if (!item) {
        showNotification("Invalid item data", "Error");
        return;
      }

      if (status === "to_po") {
        setToGeneratePo((prevToGeneratePO = []) => {
          const updatedPOItems = prevToGeneratePO.map((category) => {
            if (category.category === item.category) {
              // if item already exists in this category
              const existingItemIndex = category.items.findIndex(
                (i) => i.item_id === item.item_id,
              );

              if (existingItemIndex !== -1) {
                // Merge quantities if item exists
                const existingItem = category.items[existingItemIndex];
                const lastUnitObj = item.unit_levels?.at(-1)?.unit;

                if (!lastUnitObj || !existingItem.unit_levels) {
                  showNotification("Invalid unit data", "Error");
                  return category;
                }

                const existingQty =
                  convertToLowestUnit(
                    existingItem.unit_levels,
                    existingItem.quantity,
                  ) || 0;
                const quantityToAdd =
                  convertToLowestUnit(
                    existingItem.unit_levels,
                    item.quantity,
                  ) || 0;
                const newQuantity = [
                  {
                    unit: lastUnitObj,
                    value: Number(existingQty) + Number(quantityToAdd),
                  },
                ];
                const mergedQuantity = GetUpdatedDelivered(
                  newQuantity,
                  existingItem.unit_levels,
                );

                const mergedItem = {
                  ...existingItem,
                  quantity: mergedQuantity,
                  po_quantity: mergedQuantity,
                  total_price: calculatePrice(
                    existingItem.unit_levels,
                    mergedQuantity,
                    existingItem.po_price,
                    existingItem.unit_for_po,
                  ),
                };

                return {
                  ...category,
                  items: category.items.map((i, idx) =>
                    idx === existingItemIndex ? mergedItem : i,
                  ),
                };
              }

              // If item doesn't exist, add it
              const calculatedPrice = calculatePrice(
                item.unit_levels,
                item.quantity,
                item.po_price,
                item.unit_for_po,
              );

              return {
                ...category,
                items: [
                  ...category.items,
                  {
                    ...item,
                    order_to: "SUPPLIER",
                    total_price: calculatedPrice,
                  },
                ],
              };
            }

            return category;
          });

          // If category doesn't exist, create new
          const categoryExists = updatedPOItems.some(
            (cat) => cat.category === item.category,
          );

          if (!categoryExists) {
            const calculatedPrice = calculatePrice(
              item.unit_levels,
              item.quantity,
              item.po_price,
              item.unit_for_po,
            );

            return [
              ...updatedPOItems,
              {
                category: item.category,
                items: [
                  {
                    ...item,
                    order_to: "SUPPLIER",
                    total_price: calculatedPrice,
                  },
                ],
                suppliers: [],
                selSupp: "",
              },
            ];
          }

          return updatedPOItems;
        });

        setToDispatch(
          (prevToDispatch) =>
            prevToDispatch?.filter((i) => i.uniqueId !== item.uniqueId) || [],
        );
      } else {
        let canTransfer = true;

        const existingItem = (prevDispatch) => {
          return prevDispatch?.find((i) => i.item_id === item.item_id);
        };

        setToDispatch((prevDispatch = []) => {
          const existingItemObj = existingItem(prevDispatch);

          if (existingItemObj) {
            if (!item.unit_levels || !existingItemObj.unit_levels) {
              showNotification("Invalid unit data", "Error");
              canTransfer = false;
              return prevDispatch;
            }

            const lastUnitObj = item.unit_levels?.at(-1)?.unit;
            if (!lastUnitObj) {
              showNotification("Invalid unit data", "Error");
              canTransfer = false;
              return prevDispatch;
            }

            const existingQty =
              convertToLowestUnit(
                existingItemObj.unit_levels,
                existingItemObj.quantity,
              ) || 0;
            const quantityToAdd =
              convertToLowestUnit(existingItemObj.unit_levels, item.quantity) ||
              0;
            const newQuantity = [
              {
                unit: lastUnitObj,
                value: Number(existingQty) + Number(quantityToAdd),
              },
            ];
            const mergedQuantity = GetUpdatedDelivered(
              newQuantity,
              existingItemObj.unit_levels,
            );

            let centralAvail =
              convertToLowestUnit(
                existingItemObj.unit_levels,
                existingItemObj?.central_available,
              ) || 0;
            let quantity =
              convertToLowestUnit(
                existingItemObj.unit_levels,
                mergedQuantity,
              ) || 0;

            if (quantity > centralAvail) {
              showNotification(
                `Cannot transfer item. Requested quantity <strong>${formatQuantity(mergedQuantity)}</strong> exceeds central store available <strong>${formatQuantity(existingItemObj?.central_available || 0)}</strong>. Please edit quantity before swap.`,
                "Warning",
              );
              canTransfer = false;
            }
          } else {
            // Validate new item
            if (!item.unit_levels) {
              showNotification("Invalid unit data for new item", "Error");
              canTransfer = false;
              return prevDispatch;
            }

            let centralAvail =
              convertToLowestUnit(item.unit_levels, item?.central_available) ||
              0;
            let quantity =
              convertToLowestUnit(item.unit_levels, item.quantity) || 0;

            if (quantity > centralAvail) {
              showNotification(
                `Cannot transfer item. Requested quantity <strong>${formatQuantity(item.quantity || 0)}</strong> exceeds central store available <strong>${formatQuantity(item.central_available || 0)}</strong>. Please edit quantity before swap.`,
                "Warning",
              );
              canTransfer = false;
            }
          }

          return prevDispatch;
        });

        if (!canTransfer) {
          return;
        }

        setToDispatch((prevDispatch = []) => {
          const existingItemIndex = prevDispatch.findIndex(
            (i) => i.item_id === item.item_id,
          );

          if (existingItemIndex !== -1) {
            // Merge quantities for existing item
            const existingItem = prevDispatch[existingItemIndex];
            const lastUnitObj = item.unit_levels?.at(-1)?.unit;

            const existingQty =
              convertToLowestUnit(
                existingItem.unit_levels,
                existingItem.quantity,
              ) || 0;
            const quantityToAdd =
              convertToLowestUnit(existingItem.unit_levels, item.quantity) || 0;
            const newQuantity = [
              {
                unit: lastUnitObj,
                value: Number(existingQty) + Number(quantityToAdd),
              },
            ];
            const mergedQuantity = GetUpdatedDelivered(
              newQuantity,
              existingItem.unit_levels,
            );

            return prevDispatch.map((item, idx) =>
              idx === existingItemIndex
                ? {
                    ...existingItem,
                    quantity: mergedQuantity,
                    dispatch_quantity: mergedQuantity,
                  }
                : item,
            );
          }

          const updatedItem = {
            ...item,
            order_to: "CENTRAL STORE",
            quantity:
              item.dispatch_quantity || item.po_quantity || item.quantity,
          };

          return [...prevDispatch, updatedItem];
        });

        setToGeneratePo((prevToGeneratePO = []) => {
          const categoryIndex = prevToGeneratePO.findIndex(
            (cat) => cat.category === item.category,
          );

          if (categoryIndex !== -1) {
            const updatedCategoryItems = prevToGeneratePO[
              categoryIndex
            ].items.filter((i) => i.uniqueId !== item.uniqueId);

            if (updatedCategoryItems.length === 0) {
              return prevToGeneratePO.filter((_, idx) => idx !== categoryIndex);
            } else {
              return prevToGeneratePO.map((cat, idx) =>
                idx === categoryIndex
                  ? { ...cat, items: updatedCategoryItems }
                  : cat,
              );
            }
          }

          return prevToGeneratePO;
        });
      }
    } catch (error) {
      console.error("Error in handleTransferItem:", error);
      showNotification("An error occurred while transferring item", "Error");
    }
  };
  const [isPOGenerated, setIsPOGenerated] = useState(false);

  function checkPOItems() {
    if (toGeneratePO?.length > 0) {
      if (
        toGeneratePO.some(
          (category) =>
            category.selSupp === "" ||
            !category.selSupp ||
            (typeof category.selSupp === "object" &&
              Object.keys(category.selSupp).length === 0),
        )
      ) {
        showNotification(
          "Please select a supplier for each category",
          "Warning",
        );
        return;
      } else if (
        toGeneratePO.some((category) =>
          category.items.some((item) =>
            item.quantity.every(({ value }) => value === 0 || value === ""),
          ),
        )
      ) {
        showNotification(
          "Please enter a valid quantity for atleast one unit",
          "Warning",
        );
        return;
      } else if (
        toGeneratePO.some((category) =>
          category.items.some(
            (item) => item.po_price === null || item.po_price === 0,
          ),
        )
      ) {
        showNotification(
          "Please make sure that price is entered for all items ",
          "Warning",
        );
        return;
      }
      handleSubmitRequisition();
    } else {
      showNotification("Add at least one item", "Warning");
    }
  }

  const handleUpdateQuantity = async (quantity) => {
    let convertedQuantity = GetUpdatedDelivered(
      quantity,
      selectedItem.unit_levels,
    );
    if (editFor === "for_po") {
      const updatedData = toGeneratePO.map((category) => {
        const updatedItems = category.items.map((item) => {
          if (item.uniqueId === selectedItem.uniqueId) {
            const updatedItem = {
              ...item,
              quantity: convertedQuantity,
              dispatch_quantity: convertedQuantity,
              total_price: calculatePrice(
                item.unit_levels,
                convertedQuantity,
                item.po_price,
                item.unit_for_po,
              ),
            };
            return updatedItem;
          }
          return item;
        });
        return {
          ...category,
          items: updatedItems,
        };
      });
      let update = await handleUpdateOrder(
        selectedItem,
        convertedQuantity,
        "Update",
        "PO",
      );
      if (update) {
        setToGeneratePo(updatedData);
      } else {
        showNotification("Something went wrong", "Error");
      }
    } else if (editFor === "for_dispatch") {
      let centralAvail = convertToLowestUnit(
        selectedItem.unit_levels,
        selectedItem?.central_available,
      );
      let quantity = convertToLowestUnit(
        selectedItem.unit_levels,
        convertedQuantity,
      );
      if (quantity > centralAvail) {
        showNotification(`cannot enter more than available`, "Warning");
        return;
      }
      const updatedItems = toDispatch.map((item) => {
        if (item.uniqueId === selectedItem.uniqueId) {
          const updatedItemData = {
            ...item,
            quantity: convertedQuantity,
            dispatch_quantity: convertedQuantity.map(({ unit, value }) => ({
              unit,
              value: +value,
            })),
            total_price: calculatePrice(
              item.unit_levels,
              convertedQuantity,
              item.po_price,
              item.unit_for_po,
            ),
          };
          return updatedItemData;
        }
        return item;
      });
      let update = await handleUpdateOrder(
        selectedItem,
        convertedQuantity,
        "Update",
        "Dispatch",
      );
      if (update) {
        setToDispatch(updatedItems);
      } else {
        showNotification("Something went wrong", "Error");
      }
      // console.log(update);
      // return
    }
    setSelectedItem();
    setEditFor("");
    setEditUnitModal(false);
  };
  //#region Handle add new item in Dispatch bucket
  const [isAdding, setIsAdding] = useState(false);
  const handleAddItemInDispatch = async (e, v) => {
    try {
      e.preventDefault();
      let arrangement_quantity = [
        {
          unit: selectedItem.unit_for_max_order,
          value: Number(v.arrangement_quantity),
        },
      ];
      setIsAdding(true);
      let convertedQuantity = GetUpdatedDelivered(
        arrangement_quantity,
        selectedItem.unit_levels,
      );
      let totalEntered = convertToLowestUnit(
        selectedItem.unit_levels,
        convertedQuantity,
      );
      let totalCentralAvailable = convertToLowestUnit(
        selectedItem.unit_levels,
        selectedItem?.central_available,
      );
      if (totalEntered > totalCentralAvailable) {
        showNotification(`can not add more than available`, "Warning");
        return;
      }
      let itemToBeAdded = {
        ...selectedItem,
        arrangement_quantity: arrangement_quantity,
        quantity: convertedQuantity,
        initial_order_quantity: convertedQuantity,
        is_new_item_added: true,
        dispatch_quantity: convertedQuantity,
      };
      let payload = {
        order_id: selectedOrder.order_id,
        item_details: itemToBeAdded,
      };
      let url = process.env.REACT_APP_BASEURL + "itemorders/add_item";
      const response = await postSubmitForm(url, payload);
      if (response.status === 1) {
        showNotification(response.message, "Success");
        let updatedBucket = [...toDispatch, itemToBeAdded];
        setToDispatch(updatedBucket);
        selectRef.current.select.clearValue();
        setEnterQuantityModal(false);
        setSelectedItem();
        loadAllOrders();
        return true;
      } else {
        showNotification(response.message, "Error");
        return false;
      }
    } catch (error) {
      console.log(error, "error");
    } finally {
      setIsAdding(false);
    }
  };
  const handleDispatchOrder = async () => {
    if (isDispatched) {
      return showNotification("Already dispatched.", "Error");
    }
    setIsDispatched(true);

    let dispatch_items = toDispatch?.map((item) => {
      let obj = {
        ...item,
        quantity: item.quantity.map(({ unit, value }) => ({
          unit,
          value,
        })),
        delivered_quantity: item.quantity.map(({ unit, value }) => ({
          unit,
          value,
        })),
      };
      return obj;
    });
    let po_items = toGeneratePO?.map((category) => ({
      category: category.category,
      ...(POGenerated
        ? { supplier: category.selSupp }
        : POSaved
          ? { supplier: category.selSupp }
          : { supplier: category.selSupp.id }),
      // supplier: category.selSupp.id,
      items: category.items.map((item) => ({
        ...item,
        item_status: "PO Generated",
        quantity: item.quantity.map(({ unit, value }) => ({
          unit,
          value,
        })),
        po_quantity: item.quantity.map(({ unit, value }) => ({
          unit,
          value,
        })),
        price: +item?.po_price,
        total_price: Number(item.total_price),
      })),
    }));
    if (toDispatch.length > 0) {
      let data_to_send = {};
      data_to_send.itemorder_id = selectedOrder._id;
      data_to_send.branch_id = selectedOrder.branch_details._id;
      data_to_send.delivery_details = dispatch_items;
      data_to_send.dispatchBucket = dispatch_items;
      data_to_send.poBucket = po_items;
      data_to_send.po_bucket_status = selectedOrder.po_bucket_status;
      data_to_send.dispatch_bucket_status =
        selectedOrder.dispatch_bucket_status;
      data_to_send.isPartialDelivery = false;
      let url = process.env.REACT_APP_BASEURL + "itemorders/process_dispatch";
      // console.log(data_to_send,"DTS");return
      const response = await postSubmitForm(url, data_to_send);
      if (response && response.status === 1) {
        setToDispatch([]);
        loadAllOrders();
        setOpenBucketModal(false);
        setIsDispatched(false);
        showNotification(response.message, "Success");
      } else {
        setIsDispatched(false);
        showNotification(response.message, "Error");
      }
    } else {
      setIsDispatched(false);
      showNotification("Add at least one item.", "Warning");
    }
  };
  const [isSaving, setIsSaving] = useState(false);
  const handleSaveAsDraft = async () => {
    try {
      setIsSaving(true);
      let dispatch_bucket = toDispatch?.map((item) => {
        let obj = {
          ...item,
          quantity: item.quantity.map(({ unit, value }) => ({
            unit,
            value,
          })),
          ...(ItemsDispatched
            ? {
                delivered_quantity: item.quantity.map(({ unit, value }) => ({
                  unit,
                  value,
                })),
              }
            : {
                dispatch_quantity: item.quantity.map(({ unit, value }) => ({
                  unit,
                  value,
                })),
              }),
        };
        return obj;
      });
      let po_items = toGeneratePO?.map((category) => ({
        category: category.category,
        supplier: category.selSupp,
        items: category.items.map((item) => ({
          ...item,
          quantity: item.quantity.map(({ unit, value }) => ({
            unit,
            value,
          })),
          po_quantity: item.quantity.map(({ unit, value }) => ({
            unit,
            value,
          })),
          price: +item.po_price,
          total_price: +item.total_price,
        })),
      }));
      let data_to_send = {
        itemorder_id: selectedOrder._id,
        dispatchBucket: dispatch_bucket,
        poBucket: po_items,
        po_bucket_status: selectedOrder.po_bucket_status,
        dispatch_bucket_status: selectedOrder.dispatch_bucket_status,
      };
      if (
        data_to_send.dispatchBucket.length <= 0 &&
        data_to_send.poBucket.length <= 0
      ) {
        showNotification("Nothing to save", "Warning");
        return;
      }
      let url = process.env.REACT_APP_BASEURL + "itemorders/save_buckets";
      // console.log(data_to_send);return
      const response = await postSubmitForm(url, data_to_send);
      if (response && response.status === 1) {
        loadAllOrders();
        setOpenBucketModal(false);
        setToGeneratePo([]);
        setToDispatch([]);
        showNotification(response.message, "Success");
      } else {
        showNotification(response.message, "Error");
      }
    } catch (error) {
      console.log(error);
    } finally {
      setIsSaving(false);
    }
  };
  const handleSubmitRequisition = async () => {
    try {
      if (isPOGenerated) {
        return showNotification("PO Generated.", "Error");
      }
      setIsPOGenerated(true);
      let po_items = toGeneratePO?.map((category) => ({
        category: category.category,
        supplier: category.selSupp.id,
        items: category.items.map((item) => ({
          ...item,
          item_status: "PO Generated",
          quantity: item.quantity.map(({ unit, value }) => ({
            unit,
            value,
          })),
          po_quantity: item.quantity.map(({ unit, value }) => ({
            unit,
            value,
          })),
          price: +item.po_price,
          total_price: Number(item.total_price.toFixed(2)),
        })),
      }));
      let dispatch_items = toDispatch?.map((item) => {
        let obj = {
          ...item,
          quantity: item.quantity.map(({ unit, value }) => ({
            unit,
            value,
          })),
          ...(ItemsDispatched
            ? {
                delivered_quantity: item.quantity.map(({ unit, value }) => ({
                  unit,
                  value,
                })),
              }
            : {
                dispatch_quantity: item.quantity.map(({ unit, value }) => ({
                  unit,
                  value,
                })),
              }),
        };
        return obj;
      });
      let data_for_po = { items: po_items };
      data_for_po.branch_id = selectedOrder.branch_details._id;
      data_for_po.itemorder_id = selectedOrder._id;
      data_for_po.po_bucket_status = selectedOrder.po_bucket_status;
      data_for_po.dispatch_bucket_status = selectedOrder.dispatch_bucket_status;
      data_for_po.poBucket = po_items;
      data_for_po.dispatchBucket = dispatch_items;
      if (selectedOrder.branch_details.type === "Sub Store") {
        data_for_po.deliver_at_substore = true;
      } else if (selectedOrder.branch_details.type === "Branch") {
        data_for_po.deliver_at_branch = true;
      } else if (
        selectedOrder.branch_details.type === "CENTRAL KITCHEN STORE"
      ) {
        data_for_po.deliver_at_branch = true;
      }
      // console.log(data_for_po,"Pl");
      // return
      let url = process.env.REACT_APP_BASEURL + "itemorders/process_po";
      let response = await postSubmitForm(url, data_for_po);
      if (response.status === 1) {
        showNotification(response.message, "Success");
        loadAllOrders();
        setOpenBucketModal(false);
        setIsPOGenerated(false);
        setToGeneratePo([]);
        for (let i = 0; i < response.data.length; i++) {
          window.open(`/purchase_order?po_id=${response.data[i]}`, "_blank");
        }
      } else {
        setIsPOGenerated(false);
        showNotification(response.message, "Error");
      }
    } catch (error) {
      setIsPOGenerated(false);
      showNotification(error.message, "Error");
    }
  };

  function compareQuantities(item) {
    // console.log(item);
    if (!item.is_received) return false;
    const {
      unit_levels,
      received_quantity,
      new_delivered_quantity,
      original_delivered_quantity,
    } = item;

    // let totalReceived = convertToLowestUnit(unit_levels, received_quantity);
    let newDelivered = convertToLowestUnit(unit_levels, new_delivered_quantity);
    let originalDelivered = convertToLowestUnit(
      unit_levels,
      original_delivered_quantity,
    );
    let untracked = originalDelivered - newDelivered;

    const isQuantityChanged = Math.abs(untracked) > 0;
    // const isRemarksEmpty = !item.csm_remarks || item.csm_remarks.trim() === "";
    //  console.log(untracked,"untarcked");

    let isValid = false;
    if (isQuantityChanged) {
      isValid = true;
    }
    return isValid;
  }

  const handleCloseOrder = async (itemsForCloseOrder = []) => {
    try {
      setConfirmClose(false);
      preloader(true);

      // --- Step 1: If items exist, validate and update dispatch ---
      if (itemsForCloseOrder.length > 0) {
        const delivery_details_updates = itemsForCloseOrder.map((item) => ({
          delivery_detail_id: item._id,
          new_dispatched_quantity: item.new_delivered_quantity.map(
            ({ unit, value }) => ({ unit, value }),
          ),
          wasted_quantity: item.damaged_quantity.map(({ unit, value }) => ({
            unit,
            value,
          })),
          remarks: item.csm_remarks,
        }));

        // Validate remarks if quantities updated
        for (const item of itemsForCloseOrder) {
          const isQuantityUpdated = compareQuantities(item);
          if (isQuantityUpdated && !item.csm_remarks?.trim()) {
            showNotification(
              `Please enter remarks for updated dispatched quantity of item: <strong>${item.name}</strong>.`,
              "Warning",
            );
            return false;
          }
        }

        // Dispatch API call
        const dispatchResponse = await postSubmitForm(
          `${process.env.REACT_APP_BASEURL}itemorders/edit_dispatched_quantity`,
          { itemorder_id: selectedOrder?._id, delivery_details_updates },
        );

        if (dispatchResponse?.status !== 1) {
          showNotification(
            dispatchResponse?.message || "Failed to update dispatch.",
            "Error",
          );
          return false;
        }
      }

      // --- Step 2: Close the order (always happens if we reach here) ---
      const closeResponse = await postSubmitForm(
        `${process.env.REACT_APP_BASEURL}itemorders/set_closed`,
        { itemorder_id: selectedOrder._id, admin_remarks: adminRemarks },
      );

      if (closeResponse?.status === 1) {
        setAdminRemarks("");
        setRemarksModal(false);
        setConfirmClose(false);
        loadAllOrders();
        showNotification(closeResponse.message, "Success");
        return true;
      }

      showNotification(
        closeResponse?.message || "Failed to close order.",
        "Error",
      );
      return false;
    } catch (error) {
      console.error(error);
      showNotification(
        "Something went wrong while closing the order.",
        "Error",
      );
      return false;
    } finally {
      preloader(false);
    }
  };

  const [showDetails, setShowDetails] = useState(false);
  function openDetails(cell, row) {
    return (
      <span
        style={{
          textDecoration: "underline",
          color: "blue",
          cursor: "pointer",
        }}
        onClick={() => {
          setShowDetails(true);
          setSelectedOrder(row);
        }}
      >
        {row?.order_id}
      </span>
    );
  }

  function toggle() {
    setShowDetails(false);
  }

  const [remarksModal, setRemarksModal] = useState();
  const [adminRemarks, setAdminRemarks] = useState();

  const [orderModal, setOrderModal] = useState(false);
  const [viewOrderDetails, setViewOrderDetails] = useState({});
  const handleOpenOrder = async () => {
    let url = process.env.REACT_APP_BASEURL + "itemorders/view_orders";
    const response = await postSubmitForm(url, {
      branch_order_id: selectedOrder.branch_order_id,
    });
    if (response && response.status === 1) {
      setViewOrderDetails(response.data[0]);
      setOrderModal(true);
      // showNotification(response.message, "Success");
    } else {
      showNotification(response.message, "Error");
    }
  };
  function groupBy(array, property) {
    return Object.values(
      array.reduce((acc, obj) => {
        const key = obj[property];
        if (!acc[key]) {
          acc[key] = { category: key, items: [], suppliers: [], selSupp: "" };
        }
        acc[key].items.push(obj);
        return acc;
      }, {}),
    );
  }
  const handleDeleteRow = async (row, bucket) => {
    let update = await handleUpdateOrder(row, [], "Delete", bucket);
    if (update) {
      if (bucket === "PO") {
        setToGeneratePo((prevState) => {
          const updatedData = prevState.map((category) => {
            if (category.category === row.category) {
              const updatedItems = category.items.filter(
                (item) => item.item_id !== row.item_id,
              );

              if (updatedItems.length > 0) {
                return {
                  ...category,
                  items: updatedItems,
                  suppliers: category.suppliers || [],
                  selSupp: category.selSupp,
                };
              }
              return null;
            }
            return category;
          });
          return updatedData.filter((category) => category !== null);
        });
      } else {
        setToDispatch((prev) =>
          prev.filter((item) => item.item_id !== row.item_id),
        );
      }
    } else {
      showNotification("Something went wrong", "Error");
    }
  };
  const expandRow = {
    onlyOneExpanding: true,
    renderer: (row) => (
      <div>
        <BootstrapTable
          bootstrap4
          keyField="_id"
          data={row.item_details}
          columns={expand_columns}
          noDataIndication="No data to display."
          striped
          hover
          condensed
        />
      </div>
    ),
    // expanded: expanded,
    // onExpand: handleOnExpand,
  };
  const rowStyle = (row, rowIndex) => {
    const style = {};
    if (row.status === "Dispatched") {
      style.backgroundColor = "#b0ff9e";
    } else if (row.status === "Partially Received") {
      style.backgroundColor = "#bb87cc";
    } else if (row.status === "PO is pending") {
      style.backgroundColor = "#f7cc86";
    } else if (row.status === "Received") {
      style.backgroundColor = "#b8f3ff";
    } else {
      style.backgroundColor = "#fffbb8";
    }
    return style;
  };
  const rowStyleForDispatchBucket = (row, rowIndex) => {
    const style = { backgroundColor: "#fffbb8", fontWeight: "500" };
    if (row.is_new_item_added) {
      style.backgroundColor = "#90EE90";
    } else {
      style.backgroundColor = "";
    }
    return style;
  };

  const columns_external = columnsExternal(
    props,
    setOpenBucketModal,
    populateCartFromDraft,
    setToGeneratePo,
    setToDispatch,
    setSelectedOrder,
    openDetails,
    groupBy,
    setRemarksModal,
    remarksModal,
    setIsDispatched,
    loadMappedItems,
  );
  const expand_columns = expandColumns(props);

  const PO_Columns = poColumns(
    props,
    setSelectedItem,
    POGenerated,
    setSelectedRowsUnit,
    setEditUnitModal,
    setEditFor,
    handleDeleteRow,
    handleTransferItem,
    isTransferrable,
  );
  const dispatch_columns = dispatchColumns(
    props,
    selectedOrder,
    setSelectedItem,
    setSelectedRowsUnit,
    setEditUnitModal,
    setEditFor,
    ItemsDispatched,
    handleDeleteRow,
    handleTransferItem,
    isTransferrable,
  );
  function handleCloseModal() {
    selectRef.current.select.clearValue();
    setEnterQuantityModal(false);
    setSelectedItem();
  }
  const renderDateFields = () => {
    if (isUrgentOrders) return null;
    return (
      <Row>
        <Col lg={6}>
          <Card>
            <CardBody>
              <AvForm>
                <Row>
                  <Col lg={4} md={4} xl={4}>
                    <AvField
                      name="dateFrom"
                      label={props.t("From Date")}
                      placeholder={props.t("Select")}
                      type="date"
                      value={dateFrom}
                      onChange={(e) => {
                        const selectedDate = e.target.value;
                        setDateFrom(formatDate(selectedDate));

                        const maxDate = moment(selectedDate)
                          .add(30, "days")
                          .format("YYYY-MM-DD");
                        const currentDate = moment().format("YYYY-MM-DD");

                        if (
                          moment(dateTo).isAfter(maxDate) ||
                          moment(dateTo).isAfter(currentDate)
                        ) {
                          setDateTo(
                            maxDate > currentDate ? currentDate : maxDate,
                          );
                        }
                      }}
                      max={moment().format("YYYY-MM-DD")}
                      errorMessage={props.t("Date cannot be empty.")}
                      validate={{ required: { value: true } }}
                    />
                  </Col>
                  <Col lg={4} md={4} xl={4}>
                    <AvField
                      name="dateTo"
                      label={props.t("To Date")}
                      placeholder={props.t("Select")}
                      type="date"
                      value={dateTo}
                      onChange={(e) => {
                        const selectedDate = e.target.value;
                        setDateTo(formatDate(selectedDate));
                      }}
                      min={dateFrom}
                      max={
                        moment(dateFrom).add(30, "days").format("YYYY-MM-DD") >
                        moment().format("YYYY-MM-DD")
                          ? moment().format("YYYY-MM-DD")
                          : moment(dateFrom)
                              .add(30, "days")
                              .format("YYYY-MM-DD")
                      }
                      errorMessage={props.t("Date cannot be empty.")}
                      validate={{ required: { value: true } }}
                    />
                  </Col>
                  <Col lg={4} md={4} xl={4}>
                    <Button
                      type="submit"
                      className="btn btn-md btn-success mt-4"
                      onClick={() => {
                        if (dateFrom && dateTo) {
                          loadAllOrders();
                        }
                      }}
                    >
                      <i className="mdi mdi-checkbox-marked-circle"></i>{" "}
                      {props.t("Check")}
                    </Button>
                  </Col>
                </Row>
              </AvForm>
            </CardBody>
          </Card>
        </Col>
        <Col lg={2} className="text-center">
          <div className="bg-light p-3 rounded mt-1">
            <h5 className="font-size-14 mb-2 text-primary">
              {props.t("Total In Process")}
            </h5>
            <div className="d-flex align-items-center justify-content-center">
              <h3 className="mb-0">{allOrders?.length || 0}</h3>
            </div>
            {dateFrom && dateTo && (
              <div className="text-muted mt-2 font-size-12">
                <span className="fw-medium">
                  {moment(dateFrom).format("DD/MM/YYYY")} -{" "}
                  {moment(dateTo).format("DD/MM/YYYY")}
                </span>
              </div>
            )}
          </div>
        </Col>
      </Row>
    );
  };

  return (
    <React.Fragment>
      <div className="page-content">
        <Container fluid={true}>
          <Breadcrumb_2Items
            alternateTitle={props.t("Items")}
            title={props.t("Central Store")}
            breadcrumbItem1={props.t("Item Order")}
            breadcrumbItem2={props.t(
              `${isUrgentOrders ? "Urgent" : "New"} Orders`,
            )}
          />
          {renderDateFields()}

          <Row>
            <Col className="col-12">
              <Card>
                <CardBody>
                  <Row>
                    <Col lg={10}>
                      <div>
                        <CardTitle className="mb-2">
                          {props.t(
                            `${isUrgentOrders ? "Urgent" : "New"} Orders`,
                          )}
                        </CardTitle>
                        <CardSubtitle>
                          {props.t(
                            `View all ${isUrgentOrders ? "urgent" : "new"} orders here`,
                          )}
                        </CardSubtitle>
                      </div>
                    </Col>
                  </Row>

                  <ToolkitProvider
                    keyField="_id"
                    data={allOrders && allOrders}
                    columns={columns_external}
                    noDataIndication={props.t("No data to display.")}
                    bootstrap4
                    search
                  >
                    {(props_table) => (
                      <div>
                        <AvForm>
                          <Row>
                            <Col lg={4}>
                              <Label>{props.t("Search")}</Label>
                              <SearchBar
                                {...props_table.searchProps}
                                style={{ width: "300px" }}
                              />
                            </Col>
                            <Col lg={4}>
                              <AvField
                                name="store"
                                label={props.t("Branch / Store")}
                                type="select"
                                value={selectedStore}
                                onChange={(e) => {
                                  setSelectedStore(e.target.value);
                                }}
                              >
                                <option value="All">{props.t("All")}</option>
                                {allStores &&
                                  allStores.map((store) => {
                                    return (
                                      <option value={store._id}>
                                        {store.name}
                                      </option>
                                    );
                                  })}
                              </AvField>
                            </Col>
                            <Col lg={4}>
                              <AvField
                                name="category"
                                label={props.t("Category")}
                                type="select"
                                value={selectedCategory}
                                onChange={(e) => {
                                  setSelectedCategory(e.target.value);
                                }}
                              >
                                <option value="All">{props.t("All")}</option>
                                {allCategories &&
                                  allCategories.map((category) => {
                                    return (
                                      <option value={category.category}>
                                        {category.category}
                                      </option>
                                    );
                                  })}
                              </AvField>
                            </Col>
                          </Row>
                        </AvForm>
                        <BootstrapTable
                          striped
                          hover
                          condensed
                          expandRow={expandRow}
                          rowStyle={rowStyle}
                          {...props_table.baseProps}
                        />
                      </div>
                    )}
                  </ToolkitProvider>

                  {/* ---Open Buckets Modal Start--- */}
                  <Modal
                    size="xl"
                    style={{ maxWidth: "95%", width: "100%" }}
                    isOpen={openBucketModal}
                    toggle={() => setOpenBucketModal(!openBucketModal)}
                    // scrollable={true}
                    fade={true}
                  >
                    <Container fluid>
                      <ModalHeader
                        toggle={() => setOpenBucketModal(!openBucketModal)}
                      >
                        {selectedOrder?.order_id} &nbsp;
                        {selectedOrder?.branch_order_id && (
                          <>
                            &nbsp; Generated Against :&nbsp;
                            <span
                              style={{
                                textDecoration: "underline",
                                color: "blue",
                                cursor: "pointer",
                              }}
                              onClick={handleOpenOrder}
                            >
                              {selectedOrder?.branch_order_id}
                            </span>
                          </>
                        )}
                      </ModalHeader>

                      <ModalBody
                        style={{ display: "flex", flexDirection: "column" }}
                      >
                        <div style={{ flexGrow: 1 }}>
                          {selectedOrder.status !== "Closed" ? (
                            <>
                              {/* <Row>
                          <Col lg={12}> */}
                              <Row>
                                <Card>
                                  <CardBody>
                                    <Row>
                                      <Col lg={6}>
                                        <Row>
                                          <Col xl={6} lg={6} md={6}>
                                            <Label
                                              style={{
                                                fontWeight: "bold",
                                                fontSize: "15px",
                                              }}
                                            >
                                              {/* Dispatch Items */}
                                              {`${ItemsDispatched ? `${props.t("Dispatched Items")}` : `${props.t("Items To Dispatch ")}`}`}
                                            </Label>
                                          </Col>

                                          {/* Add Items to dispacth bucket  */}
                                          <Col xl={6} lg={6} md={6} sm={6}>
                                            <Row>
                                              <Col
                                                xl={12}
                                                lg={12}
                                                md={12}
                                                sm={12}
                                                className="mb-1 text-right"
                                                style={{ marginLeft: "-12px" }}
                                              >
                                                <Label>&nbsp;</Label>
                                                <Button
                                                  type="submit"
                                                  hidden={ItemsDispatched}
                                                  color="primary"
                                                  onClick={() =>
                                                    setEnterQuantityModal(true)
                                                  }
                                                  className="btn btn-info waves-effect waves-light btn-md"
                                                >
                                                  <i class="mdi mdi-plus-circle"></i>{" "}
                                                  {props.t("Add Item")}
                                                </Button>
                                              </Col>
                                              {/* <Col xl={2} lg={2} md={2} sm={2} style={{padding:"0px"}}>
                                      <Button
                                        type="submit"
                                        color="primary"
                                        // style={{padding:"0px"}}
                                        className="btn btn-info waves-effect waves-light btn-sm"
                                        onClick={handleAddItemInDispatch}
                                      >
                                        <i class="bx bxs-plus-circle bx-sm"></i>
                                      </Button>
                                    </Col> */}
                                            </Row>
                                          </Col>
                                        </Row>

                                        <Col lg={12} xl={12} md={12} sm={12}>
                                          <ToolkitProvider
                                            bootstrap4
                                            keyField="item_id"
                                            data={memoizedToDispatch}
                                            columns={dispatch_columns}
                                            noDataIndication={props.t(
                                              "No data to display.",
                                            )}
                                            search
                                          >
                                            {(props) => (
                                              <div>
                                                <BootstrapTable
                                                  striped
                                                  hover
                                                  condensed
                                                  rowStyle={
                                                    rowStyleForDispatchBucket
                                                  }
                                                  {...props.baseProps}
                                                />
                                              </div>
                                            )}
                                          </ToolkitProvider>
                                        </Col>
                                      </Col>
                                      <Col lg={6}>
                                        <Col xl={12} lg={12} md={12}>
                                          <Label
                                            style={{
                                              fontWeight: "bold",
                                              fontSize: "15px",
                                            }}
                                          >
                                            {/* Generate PO  */}
                                            {`${POGenerated ? `${props.t("Purchase Order generated successfully for below items")}` : `${props.t("Generate PO ")}`}`}
                                          </Label>
                                        </Col>
                                        <Col lg={12} xl={12}>
                                          {memoizedToGeneratePO &&
                                            memoizedToGeneratePO.map(
                                              (item, ind) => {
                                                if (item.items.length > 0) {
                                                  return (
                                                    <>
                                                      <Row key={ind + 1}>
                                                        <Col lg={8}>
                                                          <Label>
                                                            {props.t(
                                                              "Category",
                                                            )}
                                                            : {item.category}
                                                          </Label>
                                                        </Col>
                                                        <Col lg={4}>
                                                          <AvForm>
                                                            <div className="position-relative">
                                                              <AvField
                                                                name="supplier"
                                                                type="select"
                                                                disabled={
                                                                  POGenerated
                                                                }
                                                                value={
                                                                  item.selSupp
                                                                    ? typeof item.selSupp ===
                                                                      "object"
                                                                      ? item
                                                                          .selSupp
                                                                          .id ||
                                                                        item
                                                                          .selSupp
                                                                          .name
                                                                      : item.selSupp
                                                                    : ""
                                                                }
                                                                onClick={() =>
                                                                  loadSuupliers(
                                                                    item,
                                                                  )
                                                                }
                                                                onChange={(e) =>
                                                                  handleSupplierSelection(
                                                                    e,
                                                                    item,
                                                                  )
                                                                }
                                                              >
                                                                <option value="">
                                                                  {loadingCategory ===
                                                                  item.category
                                                                    ? props.t(
                                                                        "Loading...",
                                                                      )
                                                                    : props.t(
                                                                        "--Select Supplier--",
                                                                      )}
                                                                </option>
                                                                {item.suppliers &&
                                                                  item.suppliers.map(
                                                                    (e) => (
                                                                      <option
                                                                        key={
                                                                          e.value
                                                                        }
                                                                        value={
                                                                          e.value
                                                                        }
                                                                        name={
                                                                          e.value
                                                                        }
                                                                      >
                                                                        {e.name}
                                                                      </option>
                                                                    ),
                                                                  )}
                                                              </AvField>
                                                              {loadingCategory ===
                                                                item.category && (
                                                                <div
                                                                  className="position-absolute"
                                                                  style={{
                                                                    right:
                                                                      "30px",
                                                                    top: "50%",
                                                                    transform:
                                                                      "translateY(-50%)",
                                                                  }}
                                                                >
                                                                  <Spinner size="sm" />
                                                                </div>
                                                              )}
                                                            </div>
                                                          </AvForm>
                                                        </Col>
                                                      </Row>
                                                      <ToolkitProvider
                                                        bootstrap4
                                                        keyField="item_id"
                                                        data={item.items}
                                                        columns={PO_Columns}
                                                        noDataIndication={props.t(
                                                          "No data to display.",
                                                        )}
                                                        search
                                                      >
                                                        {(props) => (
                                                          <div>
                                                            <BootstrapTable
                                                              bootstrap4
                                                              striped
                                                              hover
                                                              condensed
                                                              {...props.baseProps}
                                                              cellEdit={cellEditFactory(
                                                                {
                                                                  mode: "click",
                                                                  blurToSave: true,
                                                                  afterSaveCell:
                                                                    (
                                                                      oldValue,
                                                                      newValue,
                                                                      row,
                                                                      column,
                                                                    ) => {
                                                                      const updatedData =
                                                                        toGeneratePO.map(
                                                                          (
                                                                            category,
                                                                          ) => {
                                                                            const updatedItems =
                                                                              category.items.map(
                                                                                (
                                                                                  item,
                                                                                ) => {
                                                                                  if (
                                                                                    item.item_id ===
                                                                                    row.item_id
                                                                                  ) {
                                                                                    const updatedItem =
                                                                                      {
                                                                                        ...item,
                                                                                        total_price:
                                                                                          calculatePrice(
                                                                                            row.unit_levels,
                                                                                            row.quantity,
                                                                                            row.po_price,
                                                                                            row.unit_for_po,
                                                                                          ),
                                                                                      };
                                                                                    return updatedItem;
                                                                                  }
                                                                                  return item;
                                                                                },
                                                                              );
                                                                            return {
                                                                              ...category,
                                                                              items:
                                                                                updatedItems,
                                                                            };
                                                                          },
                                                                        );
                                                                      setToGeneratePo(
                                                                        updatedData,
                                                                      );
                                                                    },
                                                                },
                                                              )}
                                                            />
                                                          </div>
                                                        )}
                                                      </ToolkitProvider>
                                                    </>
                                                  );
                                                }
                                              },
                                            )}
                                        </Col>
                                      </Col>
                                    </Row>
                                  </CardBody>
                                </Card>
                              </Row>
                              {/* </Col>
                        </Row> */}
                              {(selectedOrder.status === "Dispatched" ||
                                selectedOrder.status === "Partially Received" ||
                                selectedOrder.status === "Partially Received" ||
                                selectedOrder.status === "Approved" ||
                                selectedOrder.status === "PO is pending") && (
                                <Row className="mb-5">
                                  <Col xl={4} lg={4} md={4} sm={4}>
                                    <div className="text-center">
                                      <Button
                                        type="submit"
                                        color="success"
                                        style={{ width: "100px" }}
                                        className="mr-1"
                                        disabled={
                                          isDispatched || ItemsDispatched
                                        }
                                        onClick={handleDispatchOrder}
                                      >
                                        {isDispatched ? (
                                          <Spinner size="sm" />
                                        ) : (
                                          props.t("Dispatch")
                                        )}
                                      </Button>
                                    </div>
                                  </Col>
                                  <Col xl={4} lg={4} md={4} sm={4}>
                                    <div className="text-center">
                                      <Button
                                        type="submit"
                                        //  color="primary"
                                        className="mr-1"
                                        style={{ width: "150px" }}
                                        disabled={POGenerated}
                                        onClick={handleSaveAsDraft}
                                      >
                                        {isSaving ? (
                                          <Spinner size={"sm"} />
                                        ) : (
                                          props.t("Save as Draft")
                                        )}
                                      </Button>
                                    </div>
                                  </Col>
                                  <Col xl={4} lg={4} md={4} sm={4}>
                                    <div className="text-center">
                                      <Button
                                        type="submit"
                                        color="success"
                                        style={{ width: "150px" }}
                                        className="mr-1"
                                        disabled={isPOGenerated || POGenerated}
                                        onClick={checkPOItems}
                                      >
                                        {isPOGenerated ? (
                                          <Spinner size="sm" />
                                        ) : (
                                          props.t("Generate PO")
                                        )}
                                      </Button>
                                    </div>
                                  </Col>
                                </Row>
                              )}
                            </>
                          ) : null}
                        </div>
                      </ModalBody>
                    </Container>
                  </Modal>
                  {/* ---Open Bucket Modal Ends--- */}

                  {/* ---Edit Quantity Modal Starts--- */}
                  <UpdateQuantityModal
                    isOpen={editUnitModal}
                    toggle={() => setEditUnitModal(false)}
                    onSubmit={handleUpdateQuantity}
                    item={selectedItem}
                  />
                  {/* ---Edit Quantity Modal End--- */}

                  {/* ---Add/Edit Quantity Modal For New item--- */}
                  <Modal
                    size="md"
                    isOpen={enterQuantityModal}
                    toggle={handleCloseModal}
                  >
                    <ModalHeader toggle={handleCloseModal}>
                      Add Item in{" "}
                      {selectedOrder && selectedOrder.branch_details?.name}
                    </ModalHeader>
                    <ModalBody>
                      <>
                        <Card>
                          <CardSubtitle className="mb-1">
                            {props.t(
                              "Enter the following details to add item in dispatch list",
                            )}
                          </CardSubtitle>
                          <CardBody>
                            <AvForm
                              onValidSubmit={handleAddItemInDispatch}
                              ref={refForForm}
                            >
                              <Row>
                                <Col lg={12} md={12}>
                                  <Label>{props.t("Item")}</Label>
                                  <Select
                                    ref={selectRef}
                                    // value={sele}
                                    onChange={setSelectedItem}
                                    options={allMappedItems?.filter(
                                      (prod) =>
                                        !toDispatch?.some(
                                          (deliveryProd) =>
                                            deliveryProd.item_id ===
                                            prod.item_id,
                                        ),
                                    )}
                                    classNamePrefix="select2-selection"
                                    required
                                  />
                                </Col>
                                {selectedItem && (
                                  <>
                                    <Col lg={12} md={12}>
                                      <br />
                                      <p>
                                        <Label>Central Store Avl.</Label>{" "}
                                        -&nbsp;
                                        {formatUnitsForReport(
                                          selectedItem.central_available,
                                          selectedItem?.unit_levels,
                                        )}
                                        <hr
                                          style={{
                                            marginBottom: "5px",
                                            marginTop: "-5px",
                                          }}
                                        />
                                        <Label>
                                          {selectedOrder.branch_details?.name}{" "}
                                          Avl. -&nbsp;{" "}
                                        </Label>
                                        {formatUnitsForReport(
                                          selectedItem.available,
                                          selectedItem?.unit_levels,
                                        )}
                                      </p>
                                    </Col>
                                    <Col lg={12} md={12}>
                                      <Label>
                                        {props.t("Quantity")} in{" "}
                                        {`${selectedItem.unit_for_max_order}`}
                                      </Label>

                                      <AvField
                                        name="arrangement_quantity"
                                        placeholder={props.t("Enter Quantity")}
                                        type="number"
                                        min="0"
                                        step="1"
                                        validate={{
                                          required: {
                                            value: true,
                                            errorMessage:
                                              "Quantity cannot be empty.",
                                          },
                                          pattern: {
                                            value: "^[0-9]+$",
                                            errorMessage: props.t(
                                              "Only numbers are allowed.",
                                            ),
                                          },
                                          // max: {
                                          //   value:selectedProduct && selectedProduct.max_order_limit,
                                          //   errorMessage: selectedProduct &&
                                          //     props.t("Cannot enter more than ") +
                                          //     selectedProduct.max_order_limit +" " +selectedProduct.unit_for_max_order +".",
                                          // },
                                          min: {
                                            value: 1,
                                            errorMessage: props.t(
                                              "Minimum 1 is required",
                                            ),
                                          },
                                        }}
                                      />
                                    </Col>
                                  </>
                                )}

                                <Col lg={12}>
                                  <hr />
                                  <FormGroup className="mb-0 text-center">
                                    <div>
                                      <Button
                                        color="primary"
                                        className="mr-1"
                                        style={{ width: "80px" }}
                                        disabled={isAdding}
                                      >
                                        {isAdding ? (
                                          <Spinner size="sm" />
                                        ) : (
                                          props.t("Add")
                                        )}
                                      </Button>
                                    </div>
                                  </FormGroup>
                                </Col>
                              </Row>
                              {/* <Button type="submit">Submit</Button> */}
                            </AvForm>
                          </CardBody>
                        </Card>
                      </>
                    </ModalBody>
                  </Modal>
                  {/* ---Add/Edit Quantity Modal For New item End--- */}

                  {/* ---Close Reamarks Modal Start--- */}
                  <CloseOrderModal
                    isOpen={remarksModal}
                    toggle={() => setRemarksModal(false)}
                    t={props.t}
                    order={selectedOrder}
                    adminRemarks={adminRemarks}
                    setAdminRemarks={setAdminRemarks}
                    confirmClose={confirmClose}
                    setConfirmClose={() => setConfirmClose(true)}
                    onCancel={() => {
                      setConfirmClose(false);
                    }}
                    onConfirm={(items) => handleCloseOrder(items)}
                  />
                  {/* ---Close Reamarks Modal End--- */}

                  {/* ---Open Order Deatils Start--- */}
                  <OrderDetails
                    isOpen={orderModal}
                    toggle={() => setOrderModal(false)}
                    details={viewOrderDetails}
                  />
                  {/* ---Open Order Deatils end--- */}

                  {/* --- View Compleet Details start---  */}
                  <ViewCompleteDetails
                    isOpen={showDetails}
                    toggle={toggle}
                    order={selectedOrder}
                  />
                  {/* --- View Compleet Details end ---  */}
                </CardBody>
              </Card>
            </Col>
          </Row>
        </Container>
      </div>
    </React.Fragment>
  );
};

export default withRouter(
  connect(null, {})(withNamespaces()(DispatchAndGenratePO)),
);
